import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';

@Component({
  selector: 'app-college-report-details',
  templateUrl: './college-report-details.component.html',
  styleUrls: ['./college-report-details.component.scss']
})
export class CollegeReportDetailsComponent implements OnInit {


 college_id:any
  college_data:any
  transactionData=[]
  userId:any;
  enrollId:any
  studentId:any
  studentsData:any
  user_role:any
  user_type:any
  empType:any
  college_report_detail_password:any

  acc: any;
    // Prevent panel toggle code
    public beforeChange($event: NgbPanelChangeEvent) {
      if ($event.panelId === 'preventchange-2') {
        $event.preventDefault();
      }
      if ($event.panelId === 'preventchange-3' && $event.nextState === false) {
        $event.preventDefault();
      }
    };

  constructor(private apiService:ApiService,private activatedroute:ActivatedRoute,
    private modalService: NgbModal,
    private route: Router, public toastr: ToastrService,    ) { 
    this.user_role=JSON.parse(localStorage.getItem('user'))
     

    this.apiService.searchSettings('collegereportdetailkey').subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.college_report_detail_password = res?.data?.items[0]?.value
        }
      })

    
        this.activatedroute.paramMap.subscribe(params => { 
          this.college_id = params.get('id'); 
      });
    

  }

  ngOnInit(): void {
      this.confirmPasswordToDetails(this.college_id);

  }
  confirmPasswordToDetails(id){
                
      swal
      .fire({
        text: "Please Enter Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if(result.value === this.college_report_detail_password){
           this.getCollege();
        }
        else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Cancel",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
        else {
          swal.fire({
            icon: "error",
            title: "Error!",
            text: "Incorrect Password!",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  getCollege(){
    this.apiService.getCollegeById(this.college_id).subscribe((res:any)=>{
      this.college_data=res.data[0]
      this.userId=this.college_data?.user_id?._id
      // if(this.userId){
      //   this.getTransactionByUser(this.college_id)
      //   this.getStudentById(this.userId)

      // }
    })
  }
  getTransactionByUser(id){
    this.apiService.getTransactionByEnrollId(id).subscribe((res:any)=>{
      this.transactionData=res.data
    })
  }
  back(){
    this.route.navigate(['/business/college-reports'])
  }
  // openContentAddFee(id:any) {
  //   this.enrollId=id
  //   const modalRef = this.modalService.open(PopupModalComponent);
  //   modalRef.componentInstance.enrollId = this.enrollId
  //   modalRef.result.then((data) => {
  //       this.getTransactionByUser(this.enrollId)
  //   }, (reason) => {
  //     // on dismiss
  //   });
  
  // }
//   openContent(id:any,transaction_Id:any) {
//     let enrol_Id=id
//     let transaction_id=transaction_Id
//     const modalRef = this.modalService.open(PopupModalComponent);
//     modalRef.componentInstance.enrol_Id = enrol_Id;
//     modalRef.componentInstance.transaction_id = transaction_id;
//     modalRef.result.then((data) => {
//       if(data == 'success'){
//         this.getTransactionByUser(enrol_Id)
//       }
//     }, (reason) => {
//       // on dismiss
//  });
// }
// deleteTransaction(id){
//   swal.fire({
//     title: 'Are you sure?',
//     text: "You won't be able to Delete Transaction!",
//     icon: 'warning',
//     showCancelButton: true,
//     confirmButtonColor: '#2F8BE6',
//     cancelButtonColor: '#F55252',
//     confirmButtonText: 'OK',
//     customClass: {
//       confirmButton: 'btn btn-primary',
//       cancelButton: 'btn btn-danger ml-1'
//     },
//     buttonsStyling: false,
//   }).then( (result)=> {
//     if (result.value) {
//       this.apiService.deleteTransaction(id).subscribe((res:any)=>{
//           if (res.isSuccess === true) {
//             swal.fire({
//               icon: "success",
//               title: 'Deleted!',
//               text: 'Your transaction has been deleted.',
//               customClass: {
//                 confirmButton: 'btn btn-success'
//               },
//             })
//             this. getTransactionByUser(this.college_id)
//           }
//           else{
//             this.toastr.error(res.error)
//           }
     
//     })
//   }
// });
//   // this.apiService.deleteTransaction(id).subscribe((res:any)=>{
//   //   if (res.isSuccess === true) {
//   //     console.log('del res',res)
//   //     this.toastr.success(res.message)
//   //     this. getTransactionByUser()
//   //   }
//   //   else{
//   //     this.toastr.error(res.error)
//   //   }
//   // })
// }

// getStudentById(id:any){
//     this.apiService.getStudentById(id).subscribe((res:any)=>{
//     this.studentsData=res?.data
//     })

// }
// getProjectCategory(){
//     this.apiService.getTagByTagCatgoryId(this.project_cat_id).subscribe((res: any) => {
//       let data = res?.data?.filter(item => item.name ==='project')
//       this.getAllProject(data[0]?._id)
//     })
// }
// getAllProject(id){
//   this.apiService.getJobByWorkOn(id,1,100).subscribe((res:any)=>{
//     this.project_list = res?.data?.items
//   })
// }
// getProjectId(event){
//   this.selected_project
// }
// openContentProjectAssign(content,id,project_id) {
//   this.enrollId = id
//   if(project_id){
//     this.selected_project = project_id
//   }
//   const options: NgbModalOptions = {
//     size: 'md', // set the size of the modal
//     backdrop: 'static', // set whether clicking outside the modal closes it
//     centered: true // set whether the modal is centered vertically
//   };
  
//   const modalRef = this.modalService.open(content,options);

//   modalRef.result.then((result) => {
//     this.enrollId = null
//   }, (reason) => {
//     this.enrollId = null
//   });
// }

// projectAssign(){
//   let body ={
//     project_assign : this.selected_project
//   }
//   this.apiService.updateEnrolment(this.enrollId,body).subscribe((res:any)=>{
//     if(res?.statusCode === 200){
//       this.toastr.success('project assigned successfull!')
//       this.modalService.dismissAll()
//       this.getCollege();
//     }
//     else this.toastr.error(res?.error)
//   })
// }
// setToEmp(id){
//   this.apiService.changeRole(id).subscribe((res:any)=>{
//     if(res?.statusCode ===200){
//       this.toastr.success(res?.message)
//     }
//     else this.toastr.error(res?.error)
//   })
// }
}
